<app-review-detail-card
  [title]="titleKey() | translate"
  editHref="/"
  cardLayout="address"
  [testId]="'review-address-' + kind()"
  [showEdit]="showEdit()"
  (editRequested)="editRequested.emit($event)"
>
  @if (kind() === 'returnTo' && returnAddress()?.sameAsShipFrom) {
    <puro-typography component="p" variant="legal" class="review-address-summary__same-as">
      {{ 'createShipment.reviewAndPay.sameAsShipFrom' | translate }}
    </puro-typography>
  } @else {
    @let view = activeAddressView();
    @if (view) {
      @let addressLines = addressBlockLines(view);
      <div class="review-address-summary">
        @if (addressLines.length > 0) {
          <puro-typography component="p" variant="legal" class="review-address-summary__lines">
            @for (line of addressLines; track $index; let last = $last) {
              {{ line }}
              @if (!last) {
                <br />
              }
            }
          </puro-typography>
        }
        @if (view.contactName || view.email || view.phone) {
          <div class="review-address-summary__contact">
            @if (view.contactName) {
              <puro-typography component="p" variant="legal">
                {{ 'createShipment.reviewAndPay.contactNameLabel' | translate }}
                {{ view.contactName }}
              </puro-typography>
            }
            @if (view.email) {
              <puro-typography component="p" variant="legal">
                {{ 'createShipment.reviewAndPay.emailLabel' | translate }} {{ view.email }}
              </puro-typography>
            }
            @if (view.phone) {
              <puro-typography component="p" variant="legal">
                {{ 'createShipment.reviewAndPay.telLabel' | translate }} {{ view.phone }}
              </puro-typography>
            }
          </div>
        }
      </div>
    }
  }
</app-review-detail-card>
